var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Flows } from '../const';
import usePlanEligibilityCheck from './use-plan-eligibility-check';
import { useQuestionnaire } from './use-questionnaire';
import useSubmitPlanQuestionnaire from './use-submit-plan-questionnaire';
import transformAnswersToEn from '../helpers/transformAnswerstoEn';
var usePlan = function (isReady) {
    var _a, _b;
    var _c = usePlanEligibilityCheck(isReady), data = _c.data, isLoading = _c.isLoading;
    var _d = useQuestionnaire(Flows.PLAN), planData = _d.planData, questionnaire = _d.questionnaire, questionnaireActions = __rest(_d, ["planData", "questionnaire"]);
    var answersToEn = transformAnswersToEn(
    // API has trouble accepting special characters so we need
    // to convert the answers to English before submitting
    questionnaire.selectedAnswers, planData && planData.questionnaireEN);
    var submitQuestionnaire = useSubmitPlanQuestionnaire(answersToEn);
    var qualifyingPayment = (_b = (_a = submitQuestionnaire.data) === null || _a === void 0 ? void 0 : _a.mpdCalculation) === null || _b === void 0 ? void 0 : _b.qualifyingPayment;
    return __assign({ data: data, isLoading: isLoading, questionnaire: questionnaire, submitQuestionnaire: submitQuestionnaire, qualifyingPayment: qualifyingPayment, 
        /** the below two null lines make the Plan and Settlement objects the same for typescript */
        plan: null, setPlan: null }, questionnaireActions);
};
export default usePlan;
//# sourceMappingURL=use-plan.js.map